import { Component, OnInit, Input } from '@angular/core';
import { SidebarService } from '../../services/service.index';
import { AuthService } from '../../services/authorization/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styles: []
})
export class SidebarComponent implements OnInit {
  moderator: boolean;
  admin: boolean;

  constructor(public router: Router, public sidebar: SidebarService, public auth: AuthService) { }

  ngOnInit() {
    this.getClaims();
  }

  getClaims() {
    this.moderator = JSON.parse(localStorage.getItem('isModerator'));
    this.admin = JSON.parse(localStorage.getItem('isAdmin'));
  }

  logOut() {
    this.auth.signOut();
    localStorage.removeItem('isModerator');
    localStorage.removeItem('isAdmin');
    this.router.navigateByUrl('/login');
  }
  hideSidenav() {
    window.addEventListener('mouseup', function(event){
      var box = document.getElementById('sidemenu');
      if (event.target != box){
            box.style.display = 'none';
        }
    });
  }


}
